import { createRouter, createWebHistory } from 'vue-router';
import {  defaultLocale, withLocale } from "@/locales/localization";

import HomePage from '@/pages/HomePage/HomePage.vue';
import TripsPage from '@/pages/Trip/TripPage.vue';
import TripsList from "@/pages/Trip/TripList.vue";
import LoginPage from "@/pages/LoginPage/LoginPage.vue";
import ResetPassword from "@/pages/ResetPassword/ResetPassword.vue";
import SearchResults from '@/pages/SearchResults/SearchResults.vue';
import MyAccount from '@/pages/Account/Account.vue';
import CrewLists from '@/pages/CrewLists/CrewLists.vue';
import CrewDetails from '@/pages/CrewDetails/CrewDetails.vue';
import CrewDetails2 from '@/pages/CrewDetails2/CrewDetails.vue';
import Sorry from '@/pages/Sorry/Sorry.vue';
import Thankyou from '@/pages/Thankyou/Thankyou.vue';
import Comparison from '@/pages/Comparison/Comparison.vue';
import SearchResultsOffers from '@/pages/SearchResultsOffers/SearchResultsOffers.vue';
import YachtPage from '@/pages/YachtPage/YachtPage.vue';
import Terms from '@/pages/Terms/Terms.vue';
import Privacy from '@/pages/Privacy/Privacy.vue';
import FAQ from '@/pages/FAQ/FAQ.vue';
import Blog from '@/pages/Blog/Blog.vue';
import AboutPage from '@/pages/AboutPage/AboutPage.vue';
import WhyBook from '@/pages/WhyBook/WhyBook.vue';
import PageView from "@/pages/CMS/PageView.vue";
import Partners from "@/pages/Partners/Partners.vue";
import Help from "@/pages/Help/Help.vue";
import Inquiry from "@/pages/Help/Inquiry.vue";
import Imprint from "@/pages/Imprint/Imprint.vue";
import { fixLocaleInUrl } from "@/locales/localization";


const routes = [
    { path: '/', redirect: `/${defaultLocale}` },
    withLocale({ path: '/', component: HomePage }),
    withLocale({
        path: '/login',
        component: LoginPage,
        beforeEnter: (to, from, next) => {
            to.params.prevRoute = from.fullPath;
            next();
        }
    }),
    withLocale({ path: '/reset-password', component: ResetPassword }),
    withLocale({ path: '/trips', component: TripsList }),
    withLocale({ path: '/trips/:id', component: TripsPage }),
    withLocale({
        path: '/search',
        component: SearchResults,
        beforeEnter: (to, from, next) => {
            to.params.prevRoute = from.fullPath;
            next();
        }
    }),
    withLocale({ path: '/recommendations', component: SearchResultsOffers }),
    withLocale({ path: '/my-account', component: MyAccount }),
    withLocale({ path: '/crew-lists', component: CrewLists }),
    withLocale({ path: '/crew-lists/:id', component: CrewDetails }),
    withLocale({ path: '/crew-details/:id', component: CrewDetails2 }),
    withLocale({ path: '/thankyou', component: Thankyou }),
    withLocale({ path: '/terms', component: Terms }),
    withLocale({ path: '/privacy', component: Privacy }),
    withLocale({ path: '/faq', component: FAQ }),
    withLocale({ path: '/page/:slug/:child', component: PageView }),
    withLocale({ path: '/about', component: AboutPage }),
    withLocale({ path: '/blog', component: Blog }),
    withLocale({ path: '/why-book', component: WhyBook }),
    withLocale({ path: '/partners/:id', component: Partners }),
    withLocale({ path: '/yachts/compare', component: Comparison }),
    withLocale({ path: '/yachts/:id', component: YachtPage }),
    withLocale({ path: '/help', component: Help }),
    withLocale({ path: '/inquiry', component: Inquiry }),
    withLocale({ path: '/imprint', component: Imprint }),
    withLocale({ path: '/:pathMatch(.*)*', component: Sorry })
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else if (to.hash) {
            return { el: to.hash, behavior: 'smooth' };
        } else {
            return { top: 0 };
        }
    }
});



router.beforeEach((to, from, next) => fixLocaleInUrl(to, from, next));

export default router;